import React from "react";
import { AlertCircle, Inbox, Loader2 } from "lucide-react";

const TONE_STYLES = {
  loading: {
    shell: "border-slate-200 bg-white/90 text-slate-700",
    iconWrap: "bg-slate-100 text-slate-600",
    icon: Loader2,
    iconClass: "animate-spin",
  },
  error: {
    shell: "border-red-200 bg-red-50 text-red-800",
    iconWrap: "bg-white/80 text-red-600",
    icon: AlertCircle,
    iconClass: "",
  },
  empty: {
    shell: "border-slate-200 bg-slate-50 text-slate-700",
    iconWrap: "bg-white text-slate-500",
    icon: Inbox,
    iconClass: "",
  },
};

export default function SurfaceState({
  tone = "empty",
  title,
  description,
  compact = false,
  className = "",
  action = null,
}) {
  const style = TONE_STYLES[tone] || TONE_STYLES.empty;
  const Icon = style.icon;

  return (
    <div
      className={`rounded-2xl border ${style.shell} ${
        compact ? "px-4 py-4" : "px-5 py-8"
      } ${className}`.trim()}
    >
      <div className={`flex ${compact ? "items-center" : "flex-col items-center text-center"} gap-3`}>
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${style.iconWrap}`}>
          <Icon className={`h-5 w-5 ${style.iconClass}`.trim()} />
        </div>

        <div className={compact ? "min-w-0 flex-1" : "max-w-md"}>
          {title ? <div className="text-sm font-semibold">{title}</div> : null}
          {description ? (
            <div className={`${compact ? "mt-0.5" : "mt-1"} text-sm opacity-90`}>
              {description}
            </div>
          ) : null}
        </div>

        {action ? <div className={compact ? "shrink-0" : "mt-2"}>{action}</div> : null}
      </div>
    </div>
  );
}
